"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractGetTransactionData = exports.extractSendTransactionErrorData = exports.extractSimulationBaseData = exports.extractSimulationRestoreData = exports.extractSimulationErrorData = void 0;
const stellar_sdk_1 = require("@stellar/stellar-sdk");
const result_meta_xdr_1 = require("./result-meta-xdr");
const extractSimulationErrorData = (simulation) => {
    return Object.assign(Object.assign({}, (0, exports.extractSimulationBaseData)(simulation)), { error: simulation.error });
};
exports.extractSimulationErrorData = extractSimulationErrorData;
const extractSimulationRestoreData = (simulation) => {
    return Object.assign(Object.assign({}, (0, exports.extractSimulationBaseData)(simulation)), { result: simulation.result, restorePreamble: simulation.restorePreamble });
};
exports.extractSimulationRestoreData = extractSimulationRestoreData;
const extractSimulationBaseData = (simulation) => {
    return {
        id: simulation.id,
        latestLedger: simulation.latestLedger,
        events: simulation.events,
    };
};
exports.extractSimulationBaseData = extractSimulationBaseData;
const extractSendTransactionErrorData = (response) => {
    if (response.status === 'ERROR') {
        const errorResultXdrObject = response
            .errorResult;
        const errorResultXdr = errorResultXdrObject.toXDR('base64');
        return Object.assign(Object.assign({}, response), { errorResultXdr, opErrorCode: (0, result_meta_xdr_1.extractSorobanResultXdrOpErrorCode)(errorResultXdrObject) });
    }
    return Object.assign({}, response);
};
exports.extractSendTransactionErrorData = extractSendTransactionErrorData;
const extractGetTransactionData = (response) => {
    if (response.status === stellar_sdk_1.SorobanRpc.Api.GetTransactionStatus.FAILED) {
        return Object.assign({ opCode: (0, result_meta_xdr_1.extractSorobanResultXdrOpErrorCode)(response.resultXdr) }, response);
    }
    if (response.status === stellar_sdk_1.SorobanRpc.Api.GetTransactionStatus.SUCCESS) {
        return Object.assign({ opCode: (0, result_meta_xdr_1.extractSorobanResultXdrOpErrorCode)(response.resultXdr) }, response);
    }
    return Object.assign({}, response);
};
exports.extractGetTransactionData = extractGetTransactionData;
